import Popup from "./Popup";
import Share from "./Share";

export default {
  Popup,
  Share
};
